
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"682.667","height":"682.667","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M128.5 22.1C97.1 26.8 72 50.4 65.6 81.2c-1.4 6.9-1.6 26.2-1.6 178.1 0 166.4 0 170.6 2 178.1 2.8 11.1 7.3 19 15.5 27.1 8.1 8.1 16.2 12.7 27.1 15.5 13.4 3.4 27.4 2 39.2-3.9 3.3-1.7 27.2-16.3 53.1-32.5 33-20.6 48.3-29.6 51.1-30.1 8.4-1.4 10.2-.5 59.3 30.2 26 16.2 49.8 30.8 52.9 32.4 8.8 4.4 17.7 6.2 28.3 5.6 24.5-1.4 44.5-16.8 52.7-40.6l2.3-6.6v-175c0-146.3-.2-175.9-1.4-180.4-6.9-26.9-27.3-47.8-53.8-55.4l-7.8-2.2-125-.1c-68.7-.1-127.7.2-131 .7zm258.7 45.2c6.2 3 11.5 8.3 15 14.9l2.3 4.3.3 170.3c.2 155.9.1 170.6-1.4 173.8-2.4 5-6.8 7.7-13.3 8.2l-5.6.4-47.1-29.5c-25.9-16.2-49.8-30.9-53.1-32.5-17.2-8.7-39.3-8.8-56.2-.2-3.1 1.5-27 16.2-53.1 32.5l-47.5 29.7-5.6-.4c-6.5-.5-10.9-3.2-13.3-8.2-1.5-3.1-1.6-18.5-1.6-171.8 0-111.4.4-169.5 1-172 1.4-4.9 6.6-12.5 11.2-16.1 2-1.6 6.1-3.8 9-4.8 5-1.8 11.2-1.8 129.3-1.6l124 .2 5.7 2.8z"}}),_c('path',{attrs:{"d":"M161.1 130.6c-9 4.5-13.4 14-11 23.8 1.6 6.7 8.5 13.8 15.1 15.4 3.4.9 28.2 1.2 91.1 1.2 98.1 0 93.6.3 100.5-7.6 9.6-10.9 6.8-26.4-5.9-32.8l-5.3-2.6H166.4l-5.3 2.6zM161.1 219.6c-9 4.5-13.4 14-11 23.8 1.6 6.7 8.5 13.8 15.1 15.4 3.4.9 28.2 1.2 91.1 1.2 98.1 0 93.6.3 100.5-7.6 9.6-10.9 6.8-26.4-5.9-32.8l-5.3-2.6H166.4l-5.3 2.6z"}})])
          )
        }
      }
    